<form *ngIf="!isLoading && rolesList"
    [formGroup]="roleForm" (submit)="onSubmit()" class="user-form">
    <mat-form-field>
        <mat-label>{{ 'users.editForm.role.label.shortLabel' | translate }}</mat-label>
        <mat-select formControlName="role">
            <mat-option *ngFor="let role of rolesList" [value]="role.code">
                {{ role.text.shortLabel }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ 'users.editForm.maxUsers.label.shortLabel' | translate }}</mat-label>
        <input type="number" inputmode="numeric" matInput formControlName="maxUsers">
        <mat-error>{{ 'users.editForm.maxUsers.errorMessage.summary' | translate }}</mat-error>
    </mat-form-field>

    <button *ngIf="!isLoading" type="submit" mat-icon-button color="accent" [disabled]="roleForm.invalid">
        <mat-icon aria-label="Validate">check</mat-icon>
    </button>
    <button *ngIf="!isLoading" type="button" mat-icon-button (click)="onCancel()">
        <mat-icon aria-label="Cancel">clear</mat-icon>
    </button>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" ></mat-spinner>
